export default __webpack_public_path__ + "static/media/284.6ce24507.png";